$(function () {
  var scrollToElement = function ($element) {
    if (!$element) {
      return;
    }
    var headerHeight = $('.js-global-header').height();
    var targetPosition = $element.position().top + headerHeight;
    $('html, body').animate(
      {
        scrollTop: targetPosition
      },
      'fast'
    );
  };

  $(document).on('click', '.js-customerReviewLink', function (evt) {
    // scroll to review area
    scrollToElement($($(this).attr('href')));
    return false;
  });
});

$(function () {
  tom.helper.trackAction('ec_shop', 'load', 'detail', 1);

  // 説明文の折りたたみ
  (function () {
    var $moreInfoTrigger = $('#js-more-info-trigger');
    var $moreInfoTriggerIcon = $('#js-more-info-trigger__icon');
    var $moreInfoContents = $('#js-more-info-contents');

    var moreInfoContentsMinH = 140;
    var moreInfoContentsMaxH = $moreInfoContents.outerHeight(true);

    var classContentOpen = 'open';
    var classIconUp = 'icon-angle-up';
    var classIconDown = 'icon-angle-down';

    // コンテンツの高さが最小高に満たない場合は折りたたまない
    if (moreInfoContentsMaxH < moreInfoContentsMinH) {
      $moreInfoTrigger.hide();
      return;
    }

    $moreInfoContents.css({
      height: moreInfoContentsMinH
    });

    $moreInfoTrigger.on('click', function () {
      var willExpand = $moreInfoContents.attr('aria-expanded') === 'false';
      var contentH = willExpand ? moreInfoContentsMaxH : moreInfoContentsMinH;
      $moreInfoTriggerIcon.toggleClass(classIconDown).toggleClass(classIconUp);
      $moreInfoContents
        .toggleClass(classContentOpen)
        .attr('aria-expanded', willExpand ? 'true' : 'false')
        .animate(
          {
            height: contentH
          },
          200,
          'linear'
        );
    });
  })();
});
